// The page "Go to Dashboard" opens; chosen in Settings → Preferences.
const DEFAULT_DASHBOARD_KEY = "default_dashboard";

export const DASHBOARD_OPTIONS = [
  { value: "Inventory", label: "Inventory", path: "/inventory" },
  { value: "Events", label: "Events", path: "/events" },
  { value: "Finance", label: "Finance", path: "/finance" },
] as const;

export type DashboardChoice = (typeof DASHBOARD_OPTIONS)[number]["value"];

export const getDefaultDashboard = (): DashboardChoice => {
  try {
    const saved = localStorage.getItem(DEFAULT_DASHBOARD_KEY);
    const match = DASHBOARD_OPTIONS.find((o) => o.value === saved);
    return match ? match.value : "Inventory";
  } catch {
    return "Inventory";
  }
};

export const setDefaultDashboard = (value: DashboardChoice) => {
  try {
    localStorage.setItem(DEFAULT_DASHBOARD_KEY, value);
  } catch {
    // storage unavailable: Inventory stays the default
  }
};

export const defaultDashboardPath = () =>
  DASHBOARD_OPTIONS.find((o) => o.value === getDefaultDashboard())!.path;
